import * as React from "react";
import { SVGProps } from "react";

const FlagNigeria = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6H20V18H4V6Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.665 6H20V18H14.665V6ZM4 6H9.3325V18H4V6Z"
      fill="#008753"
    />
  </svg>
);
export default FlagNigeria;
